// extracted by mini-css-extract-plugin
export default {"timeText":"styles_timeText__SgGhz"};